
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "40px",
    "height": "40px",
    "viewBox": "0 0 40 40",
    "enable-background": "new 0 0 40 40",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "fill": "#51565D",
            "d": "M40,31.488C40,36.17,36.17,40,31.489,40H8.511C3.83,40,0,36.17,0,31.488V8.512C0,3.83,3.83,0,8.511,0\r\n\t\th22.978C36.17,0,40,3.83,40,8.512V31.488z"
          }
        }
      ]
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#BBBBBB",
        "d": "M25.777,17.305c0,0.492-1.684,1.479-5.41,1.479s-5.398-0.986-5.398-1.479c0-2.248,0.744-3.18,3.646-4.111\r\n\tc0.666-0.215,0.891-0.623,0.691-1.133c-0.199-0.514-1.361-0.729-1.555-3.068c-0.189-2.311,0.863-3.25,2.615-3.25\r\n\ts2.805,0.939,2.615,3.25c-0.193,2.34-1.355,2.555-1.557,3.068c-0.199,0.51,0.027,0.92,0.693,1.133\r\n\tC25.029,14.125,25.777,15.057,25.777,17.305z M12.809,26.236c-0.666-0.215-0.893-0.625-0.691-1.135\r\n\tc0.199-0.514,1.361-0.729,1.555-3.068c0.189-2.311-0.863-3.25-2.615-3.25s-2.805,0.939-2.615,3.25\r\n\tc0.193,2.34,1.355,2.555,1.557,3.068c0.199,0.51-0.027,0.92-0.693,1.135c-2.898,0.93-3.646,1.861-3.646,4.109\r\n\tc0,0.492,1.674,1.479,5.398,1.479c3.727,0,5.41-0.986,5.41-1.479C16.467,28.098,15.721,27.166,12.809,26.236z M25.039,26.457\r\n\tl-3.734-2.156v-4.518c-0.305,0.016-0.615,0.025-0.938,0.025c-0.32,0-0.625-0.01-0.926-0.023v4.516l-3.729,2.152\r\n\tc0.572,0.402,1.004,0.855,1.285,1.41l3.375-1.951l3.381,1.955C24.033,27.316,24.463,26.857,25.039,26.457z M31.441,26.236\r\n\tc-0.668-0.215-0.895-0.625-0.693-1.135c0.199-0.514,1.361-0.729,1.555-3.068c0.189-2.311-0.861-3.25-2.615-3.25\r\n\tc-1.752,0-2.803,0.939-2.615,3.25c0.193,2.34,1.355,2.555,1.557,3.068c0.199,0.51-0.027,0.92-0.693,1.135\r\n\tc-2.9,0.93-3.646,1.861-3.646,4.109c0,0.492,1.672,1.479,5.398,1.479s5.408-0.986,5.408-1.479\r\n\tC35.096,28.098,34.352,27.166,31.441,26.236z"
      }
    }
  ]
})
    }
  